import * as Yup from 'yup'

import { AD_CREATIVES, CLICK_THROUGH_LINK, MEDIA_HEIGHT, MEDIA_WIDTH, NAME, THIRD_PARTY_TAG } from '../../../../fields'
import { urlValidation } from '../../../../../../../features/validations/other'
import { DISPLAY_DEFAULT } from '../../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

export const validationSchema = lineItemType => {
  return Yup.object({
    [AD_CREATIVES]: Yup.array().of(
      Yup.object().shape({
        [NAME]: Yup.string().required('Name is required'),
        [THIRD_PARTY_TAG]: Yup.string().required('Third party tag is required'),
        ...(lineItemType === DISPLAY_DEFAULT && {
          [CLICK_THROUGH_LINK]: urlValidation,
          [MEDIA_WIDTH]: Yup.number().required('Width is required'),
          [MEDIA_HEIGHT]: Yup.number().required('Height is required')
        })
      })
    )
  })
}
